import { pendingRequests } from '../api/instances/smartsolve';
import { pageLoadChecked, setPageLoad } from '../components/Layout';
import { endTimer, PAGE_LOAD_TIMER } from '../utils/log';

const VALIDATION_DELAY = process.env.NODE_ENV === 'test' ? 0 : 500;

let performanceTimer = undefined;
export const body = document.getElementsByTagName('body')[0];

export const performanceChecker = () => (next) => (action) => {
  next(action);

  clearTimeout(performanceTimer);

  performanceTimer = setTimeout(() => {
    if (document.readyState === 'complete' && pendingRequests === 0 && !pageLoadChecked) {
      const time = endTimer(PAGE_LOAD_TIMER);
      body.setAttribute('data-loaded', true);

      // eslint-disable-next-line no-console
      console.log(`🕑 Page Load time: ${time}s`);
      setPageLoad(true);
    }
  }, VALIDATION_DELAY);
};
